import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotificationErrorService } from 'src/app/modules/acbcr/common/services/notification-error.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HoldingsTableService } from 'src/app/modules/acbcr/common/services/holdings-table.service'
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';

@Component({
  selector: 'app-registru-de-monte-si-fatari',
  templateUrl: './registru-de-monte-si-fatari.component.html',
  styleUrls: ['./registru-de-monte-si-fatari.component.scss']
})
export class RegistruDeMonteSiFatariComponent {
  @ViewChild('registruMonteFatari') registruMonteFatari: ElementRef;
  @Input() modalData = {};

  modalReference: NgbModalRef;
  form: UntypedFormGroup;
  numeExploatatie;
  codExploatatie;
  idExploatatie;
  loadingSpinner = false;

  constructor(
    public modalService: NgbModal,
    public errorService: NotificationErrorService,
    private holdingsTableService: HoldingsTableService,
    private helperDataService: HelperDataService,
  ) { }

  ngOnChanges(changes) {
    this.loadingSpinner = false;
    this.form = new UntypedFormGroup({
      exploatatie_id: new UntypedFormControl(),
    })

    if (changes.modalData && this.modalData && this.modalData['exploatatie']) {
      this.numeExploatatie = this.modalData['exploatatie']['name'];
      this.codExploatatie = this.modalData['exploatatie']['code'];
      this.idExploatatie = this.modalData['exploatatie']['id'];
      this.form.controls.exploatatie_id.setValue(this.idExploatatie);
      this.modalReference = this.modalService.open(this.registruMonteFatari);
    }
  }

  onSubmitted() {
    this.loadingSpinner = true;

    this.holdingsTableService.registruMonteFatariAPI(this.form.value)
      .subscribe({
        next: (response) => {
          let now = UIHelper.now();
          let fisier = `Registru_de_monte_si_fatari_${now}.pdf`;
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);

          this.modalReference.close();
          this.loadingSpinner = false;
        },
        error: (errors) => {
          this.loadingSpinner = false;
        }
      });

  }
}
